import React, { CSSProperties } from 'react';
import './Skeleton.css';

interface Props {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  /** CSS border-radius; use '50%' for avatars. */
  radius?: CSSProperties['borderRadius'];
  className?: string;
}

/** A grey shape that stands in for content while it loads. Decorative: wrap groups in <SkeletonGroup>. */
const Skeleton: React.FC<Props> = ({ width, height, radius, className = '' }) => (
  <span
    className={`skeleton ${className}`.trim()}
    style={{ width, height, borderRadius: radius }}
    aria-hidden="true"
  />
);

/** Lines of placeholder text; the last line is shorter, like a real paragraph. */
export const SkeletonText: React.FC<{ lines?: number; lineHeight?: string }> = ({ lines = 3, lineHeight = '0.85rem' }) => (
  <span className="skeleton-text" aria-hidden="true">
    {Array.from({ length: lines }, (_, i) => (
      <Skeleton key={i} height={lineHeight} width={i === lines - 1 && lines > 1 ? '62%' : '100%'} />
    ))}
  </span>
);

/** Announces loading once to screen readers and hides the shapes themselves. */
export const SkeletonGroup: React.FC<{ label: string; className?: string; children: React.ReactNode }> = ({ label, className = '', children }) => (
  <div className={className} role="status" aria-live="polite" aria-busy="true">
    <span className="sr-only">{label}</span>
    {children}
  </div>
);

export default Skeleton;
